// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-menu {
  padding: 6px;
  margin: 0;
  background: transparent;
}

.action-menu__item {
  --min-height: 44px;
  --padding-start: 8px;
  --inner-padding-end: 8px;
  --border-radius: 8px;
  --background: transparent;
  --background-hover: var(--ion-color-primary);
  --background-hover-opacity: 0.06;
  --ripple-color: var(--ion-color-primary);
  font-size: 14.5px;
  border-radius: 8px;
}
.action-menu__item ion-label {
  margin: 0;
  white-space: normal;
}
.action-menu__item--danger {
  --color: var(--ion-color-danger);
  --background-hover: var(--ion-color-danger);
  --background-hover-opacity: 0.1;
  --ripple-color: var(--ion-color-danger);
}

.action-menu__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  margin-inline-end: 12px;
  border-radius: 50%;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.1);
}
.action-menu__icon ion-icon {
  font-size: 17px;
}
.action-menu__item--danger .action-menu__icon {
  color: var(--ion-color-danger);
  background: rgba(var(--ion-color-danger-rgb), 0.1);
}

.action-menu__separator {
  height: 1px;
  margin: 6px 8px;
  background: rgba(var(--ion-color-medium-rgb), 0.2);
}`, "",{"version":3,"sources":["webpack://./src/components/popup/popover-action-menu/popover-action-menu.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,SAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,oBAAA;EACA,yBAAA;EACA,4CAAA;EACA,gCAAA;EACA,wCAAA;EACA,iBAAA;EACA,kBAAA;AACF;AACE;EACE,SAAA;EACA,mBAAA;AACJ;AAEE;EACE,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;EACA,mDAAA;AADF;AAGE;EACE,eAAA;AADJ;AAIE;EACE,8BAAA;EACA,kDAAA;AAFJ;;AAMA;EACE,WAAA;EACA,eAAA;EACA,kDAAA;AAHF","sourcesContent":[".action-menu {\n  padding: 6px;\n  margin: 0;\n  background: transparent;\n}\n\n.action-menu__item {\n  --min-height: 44px;\n  --padding-start: 8px;\n  --inner-padding-end: 8px;\n  --border-radius: 8px;\n  --background: transparent;\n  --background-hover: var(--ion-color-primary);\n  --background-hover-opacity: 0.06;\n  --ripple-color: var(--ion-color-primary);\n  font-size: 14.5px;\n  border-radius: 8px;\n\n  ion-label {\n    margin: 0;\n    white-space: normal;\n  }\n\n  &--danger {\n    --color: var(--ion-color-danger);\n    --background-hover: var(--ion-color-danger);\n    --background-hover-opacity: 0.1;\n    --ripple-color: var(--ion-color-danger);\n  }\n}\n\n.action-menu__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  margin-inline-end: 12px;\n  border-radius: 50%;\n  color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.1);\n\n  ion-icon {\n    font-size: 17px;\n  }\n\n  .action-menu__item--danger & {\n    color: var(--ion-color-danger);\n    background: rgba(var(--ion-color-danger-rgb), 0.1);\n  }\n}\n\n.action-menu__separator {\n  height: 1px;\n  margin: 6px 8px;\n  background: rgba(var(--ion-color-medium-rgb), 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
